// extracted by mini-css-extract-plugin
export default {"newCursoContainer":"TableCurso_newCursoContainer__nTrwP","container":"TableCurso_container__z+OAi"};